"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.provide = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("./provider");
exports.provide = ((stores, fallback) => (Component) => props => ((0, jsx_runtime_1.jsx)(provider_1.Provider, Object.assign({}, stores, { fallback: fallback }, { children: (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props), void 0) }), void 0)));
//# sourceMappingURL=provide.js.map